import { render } from "./ProcessingHistory.vue?vue&type=template&id=4eb214c2"
import script from "./ProcessingHistory.vue?vue&type=script&lang=js"
export * from "./ProcessingHistory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__